import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title, 
  description, 
  keywords = [], 
  image = '/icon.png',
  url = '',
  type = 'website'
}) => {
  const siteUrl = 'https://habbaevents.com';
  const fullUrl = `${siteUrl}${url}`;
  const defaultTitle = 'Habba Events - Event Decoration Booking in Bangalore';
  const defaultDescription = 'Book party halls, event spaces, and celebration venues in Bangalore.Habba Events offers premium venues with modern amenities for all your special occasions.';

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title ? `${title} | Habba Events` : defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}

      {/* OpenGraph Meta Tags */}
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={`${siteUrl}${image}`} />
      <meta property="og:site_name" content="" />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={`${siteUrl}${image}`} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Geo Meta Tags */}
      <meta name="geo.region" content="IN-KA" />
      <meta name="geo.placename" content="Bangalore" />
      <meta name="geo.position" content="12.9716;77.5946" />
      <meta name="ICBM" content="12.9716, 77.5946" />
    </Helmet>
  );
};

export default SEO; 